import React, { ChangeEvent, FC, useState } from 'react';
import RegNumbersService from '~/src/services/reg-numbers.service';
import Textbox from '~/src/components/form-components/textbox/textbox';
import { INN_ERROR } from '~/src/components/common-components/inn-field/inn-field.constants';
import { LegalFormEnum } from '~/src/models/enums/legal-form.enum';
import type { TextBoxFieldProps } from '~/src/models/types/fields.types';

export const InnField: FC<TextBoxFieldProps> = ({ onValueChange, onClear, error, inputErrorRef, ...props }) => {
    const [innValue, setFioValue] = useState('');
    const [isValid, setIsValid] = useState(false);
    const [errorInn, setErrorInn] = useState('');

    const checkError = (value: string) => {
        const isValid = RegNumbersService.checkValidLength('inn', value || innValue, LegalFormEnum.SELF_EMPLOYEE);
        setIsValid(isValid);

        if (!isValid && value) {
            setErrorInn(error || INN_ERROR);
            return;
        }

        setErrorInn('');
    };


    const onBlurHandler = async () => {
        checkError(innValue);
    };

    const onInnValidHandler = (event: ChangeEvent<HTMLInputElement>) => {
        onValueChange && onValueChange(event);
        const _value = (event.target.value).replace(/\D/g, '');
        setFioValue(_value);
        checkError(_value);
    };

    const handleClear = () => {
        onClear && onClear();
        setFioValue('');
    };

    return (
        <Textbox
            value={innValue}
            onValueChange={(e) => onInnValidHandler(e)}
            onClear={handleClear}
            maxLength={RegNumbersService.getMaxLength(LegalFormEnum.SELF_EMPLOYEE, 'inn')}
            inputErrorRef={inputErrorRef}
            error={errorInn}
            onBlurHandler={onBlurHandler}
            validated={isValid}
            {...props}
        />
    );
};
